import { Box, CardMedia, Dialog, IconButton, Typography } from "@mui/material";
import { userState } from "../../interface/MainInterface";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import Toast from "../../utils/Toast";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { useNavigate } from "react-router-dom";

interface propsType {
  userState: userState;
  // selectedKeywords: any;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const PopChangeCtg = (props: propsType, ref: any) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [selectedBriefKeys, setSelectedBriefKeys] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);
  const [showCategory, setShowCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>({key: "fashion", value: "패션"});

  useEffect(() => {
    get_category_list();
  }, []);

  const open = useCallback((list: any) => {
    setSelectedBriefKeys(list);
    // get_scrap_list();
    setOpenModal(true);
    setShowCategory(false);
  }, []);

  const close = () => {
    props.callback({ command: "close" });
    setSelectedBriefKeys([]);
    setOpenModal(false);
    setShowCategory(false);
  };

  const get_category_list = async () => {
    const param: any = {
      command: "get_category_list",
      pk: "trendreport#category",
      sk: "all",
    };
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setCategories(res.response.category_list);
    } else {
      console.error("[ERROR] get_category_list : ", res.response.error_msg);
    }
  };

  const update_brief_category = async () => {
    if (selectedBriefKeys.length === 0) {
      toastRef.current?.toast("카테고리를 변경할 브리프가 없습니다.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }

    const param: any = {
      command: "update_brief_category2",
      category: selectedCategory,
      briefKeys: selectedBriefKeys, 
    }
    console.log(selectedCategory);
    
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      window.location.reload();
    } else {
      console.error(res.response.error_msg);
      toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
    setIsLoading(false);
    setOpenModal(false);
    setSelectedBriefKeys([]);
  };

  const selectCategory = (category: any) => {
    setShowCategory(false);
    setSelectedCategory(category);
  }

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <>
      <Dialog
        open={openModal}
        // onClose={close}
        PaperProps={{
          style: {
            width: "100%",
            maxWidth: "500px",
            background: "#ffffff",
            borderRadius: "30px",
          },
        }}
      >
        <Box className="scrap-modal">
          <Box className="header">
            <Box className="title">
              <Typography className="text">{"카테고리 변경"}</Typography>
            </Box>
            <Box className="btn">
              <IconButton
                onClick={() => {
                  close();
                }}
              >
                <CardMedia component={"img"} image="/images/icon-close-m-blk.png" sx={{ height: "22px" }} />
              </IconButton>
            </Box>
          </Box>
          <Box className="title-margin"></Box>
          <div className="category-list-wrap" style={{ padding: "0px 16px 16px 16px"}}>
            <div className="option-wrap">
              <div className="category" style={{ width: "100%" }}>
                <div className={showCategory ? "category_select_wrap active" : "category_select_wrap"} >
                  <ul className="default_option" style={{ width: "100%" }}>
                    <li
                      onClick={() => {
                        setShowCategory(!showCategory);
                      }}
                    >
                      {selectedCategory.value}
                    </li>
                  </ul>
                  <ul className="select_ul" style={{ width: "100%", maxHeight: "200px" }}>
                    {categories.map((category: any, index: number) => (
                      <li
                        key={`category-${index}`}
                        onClick={() => {
                          selectCategory(category);
                        }}
                      >
                        {category.value}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div style={{ height: showCategory ? "200px" : "20px" }} />
          <Box sx={{ display: "flex", justifyContent: "center", p: "24px" }}>
            <Box
              sx={{ display: "flex", justifyContent: "center", width: "100%" }}
              className={selectedBriefKeys ? "btn-add-scrap add-scrap-able" : "btn-add-scrap"}
            >
              <button
                style={{ width: "100%" }}
                onClick={() => {
                  if (selectedBriefKeys) {
                    update_brief_category();
                  }
                }}
              >
                <i>
                  <span>변경하기</span>
                </i>
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
      <Toast ref={toastRef} />     
    </>
  )
}

export default forwardRef(PopChangeCtg);